<template>
    <div v-if="banner !== null && isEnabled" class="banner">
        <a :href="banner.data.banner_link.url" target="_blank">
            <div
                class="banner_image"
                :class="{
                    image: image !== null,
                    hasImage: image !== null
                }"
                :style="getStyle(banner)"
            ></div>
            <div class="banner_title" v-if="banner.data.show_title">
                <span class="badge">Ad</span>
                <h2>{{ title }}</h2>
                <p>{{ description }}</p>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                isEnabled: false,
                banner: null,
                image: null,
                icon: 'mail-unread',
                title: 'Banner',
                description: 'Contact us via <a href="mailto:info@onemgl.com">info@onemgl.com</a> to place your ad here.'
            }
        },
        mounted(){

            this.$prismic.client.getSingle('banner').then((document) => {

                // console.log('Banner: ', document)
                
                this.banner = document
                this.image = document.data.banner_image.url

                if(this.banner.data.enable_banner){
                    this.isEnabled = true
                }
                if(this.banner.data.banner_title){
                    this.title = this.banner.data.banner_title[0].text
                }
                if(this.banner.data.banner_description){
                    this.description = this.banner.data.banner_description[0].text
                }
            })
        },
        methods: {
            getStyle(banner){

                let bannerStyle = ''

                if(banner.data.banner_image.url !== null){
                    bannerStyle += ' background-image:url('+ banner.data.banner_image.url +');'
                }
                if(banner.data.background_color){
                    bannerStyle += ' background-color:'+ banner.data.background_color +';'
                }

                return bannerStyle
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Banner.vue